import { useEffect, useState } from 'react';

const ICON_HEIGHT = 24;

const MaterialIconSwipeAnimation = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [enableTransition, setEnableTransition] = useState(true);
  const icons = [Gun, Close, Versus, Heart, HeartBroken, Love];
  const loopIcons = [...icons, icons[0]];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => prev + 1);
    }, 1200);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (activeIndex === icons.length) {
      // 마지막(복제된 첫 아이콘)까지 도달하면, 애니메이션 없이 인덱스를 0으로 순간 이동
      const timeout = setTimeout(() => {
        setEnableTransition(false);
        setActiveIndex(0);
      }, 500); // transition 시간과 맞춤

      return () => clearTimeout(timeout);
    }

    if (!enableTransition && activeIndex === 0) {
      const raf = requestAnimationFrame(() => {
        setEnableTransition(true);
      });
      return () => cancelAnimationFrame(raf);
    }
  }, [activeIndex, icons.length, enableTransition]);

  return (
    <div
      style={{
        overflow: 'hidden',
        height: ICON_HEIGHT,
        width: ICON_HEIGHT,
        display: 'inline-block'
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          transform: `translateY(-${activeIndex * ICON_HEIGHT}px)`,
          transition: enableTransition ? 'transform 0.5s ease-in-out' : 'none'
        }}
      >
        {loopIcons.map((Icon, index) => (
          <div
            key={Icon.name ?? index}
            style={{
              height: ICON_HEIGHT,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Icon />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MaterialIconSwipeAnimation;

const Gun = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-label="gun"
      role="img"
    >
      <path
        d="M6.99992 5H22.9999V9H21.9999V10H15.9999C15.7347 10 15.4804 10.1054 15.2928 10.2929C15.1053 10.4804 14.9999 10.7348 14.9999 11V12C14.9999 12.5304 14.7892 13.0391 14.4141 13.4142C14.0391 13.7893 13.5304 14 12.9999 14H9.61992C9.23992 14 8.88992 14.22 8.71992 14.56L6.26992 19.45C6.09992 19.79 5.75992 20 5.37992 20H1.99992C1.99992 20 -1.00008 20 2.99992 14C2.99992 14 5.99992 10 1.99992 10V5H2.99992L3.49992 4H6.49992L6.99992 5ZM13.9999 12V11C13.9999 10.7348 13.8946 10.4804 13.707 10.2929C13.5195 10.1054 13.2651 10 12.9999 10H11.9999C11.9999 10 10.9999 11 11.9999 12C11.4695 12 10.9608 11.7893 10.5857 11.4142C10.2106 11.0391 9.99992 10.5304 9.99992 10C9.7347 10 9.48035 10.1054 9.29282 10.2929C9.10528 10.4804 8.99992 10.7348 8.99992 11V12C8.99992 12.2652 9.10528 12.5196 9.29282 12.7071C9.48035 12.8946 9.7347 13 9.99992 13H12.9999C13.2651 13 13.5195 12.8946 13.707 12.7071C13.8946 12.5196 13.9999 12.2652 13.9999 12Z"
        fill="white"
      />
    </svg>
  );
};

const Heart = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-label="heart"
      role="img"
    >
      <path
        d="M12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 12.27 18.6 15.36 13.45 20.03L12 21.35Z"
        fill="white"
      />
    </svg>
  );
};

const Close = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-label="double headed arrow"
      role="img"
    >
      <path
        d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
        fill="white"
      />
    </svg>
  );
};

const Versus = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-label="versus"
      role="img"
    >
      <path
        d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM7.86621 9.50684C7.66245 9.08869 7.19609 8.99793 6.85352 9.09668C6.66611 9.1507 6.48416 9.26675 6.37207 9.44824C6.25532 9.63764 6.23124 9.87256 6.32129 10.1182V10.1191L8.20898 15.207H8.20996C8.39414 15.7014 8.79449 15.9789 9.22949 15.9736C9.66127 15.9682 10.0636 15.6853 10.2598 15.1973L10.2617 15.1934L12.2051 10.0889L12.207 10.0859C12.2924 9.8524 12.2642 9.62834 12.1514 9.44824C12.0433 9.27578 11.8697 9.16201 11.6904 9.10742C11.34 9.00086 10.8511 9.10004 10.6807 9.58691L9.26367 13.5068L7.9043 9.59766L7.90332 9.59473L7.86621 9.50684ZM15.2285 9.05371C13.7637 9.05371 12.8263 9.95886 12.8262 11.0479C12.8262 11.6104 13.031 12.0518 13.3535 12.3789C13.6706 12.7004 14.091 12.902 14.5146 13.0176H14.5176L15.1631 13.1846V13.1855C15.4885 13.2736 15.6777 13.372 15.7852 13.4766C15.8805 13.5696 15.9297 13.6861 15.9297 13.8721C15.9297 14.0455 15.8667 14.1798 15.7412 14.2773C15.6078 14.3809 15.3788 14.4619 15.0205 14.4619C14.5966 14.4619 14.1739 14.2861 13.877 14.0762L13.8711 14.0723L13.7969 14.0273C13.6233 13.9331 13.4403 13.906 13.2686 13.9414C13.076 13.9812 12.9149 14.0956 12.8086 14.2441C12.5908 14.5484 12.5942 15.0058 12.9697 15.3262L12.9746 15.3301C13.4631 15.7279 14.1963 15.9541 15.0361 15.9541C15.7913 15.9541 16.4262 15.7358 16.876 15.3418C17.3282 14.9456 17.5742 14.3876 17.5742 13.752C17.5742 13.1942 17.3629 12.7478 17.0156 12.4121C16.7169 12.1234 16.3255 11.9233 15.8984 11.793L15.7139 11.7422L15.1016 11.5752L15.0986 11.5742L14.9062 11.5156C14.7376 11.4551 14.6358 11.3892 14.5742 11.3242C14.5008 11.2468 14.462 11.1469 14.4619 10.9844C14.4619 10.8745 14.5158 10.7658 14.6436 10.6758C14.7748 10.5833 14.9825 10.5137 15.2598 10.5137C15.7109 10.5137 16.0818 10.6573 16.3271 10.8115L16.3311 10.8145C16.5268 10.9319 16.7347 10.9572 16.9229 10.9004C17.1056 10.8451 17.2499 10.7181 17.3398 10.5684C17.5197 10.2686 17.5096 9.82023 17.125 9.54785L17.1201 9.54492L16.9697 9.45312C16.5901 9.24123 16.0023 9.05378 15.2285 9.05371Z"
        fill="white"
      />
    </svg>
  );
};

const HeartBroken = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-label="heart broken"
      role="img"
    >
      <path
        d="M8.106 18.247C5.298 16.083 2 13.542 2 9.137C2 4.537 6.923 1.202 11.264 4.814L9.81 8.204C9.7425 8.36122 9.73079 8.5368 9.77681 8.70159C9.82283 8.86639 9.92381 9.01049 10.063 9.11L12.896 11.134L10.43 14.012C10.3071 14.1554 10.2429 14.3399 10.2501 14.5286C10.2574 14.7174 10.3355 14.8964 10.469 15.03L12.169 16.73L11.259 20.37C10.503 20.117 9.743 19.527 8.961 18.91C8.683 18.6927 8.39767 18.4717 8.105 18.247"
        fill="white"
      />
      <path
        d="M12.8118 20.345C13.5438 20.08 14.2808 19.508 15.0378 18.911C15.3158 18.6923 15.6011 18.471 15.8938 18.247C18.7018 16.083 21.9998 13.542 21.9998 9.13701C21.9998 4.62201 17.2588 1.32701 12.9798 4.61901L11.4268 8.24101L14.4358 10.39C14.5203 10.4505 14.5914 10.528 14.6445 10.6175C14.6975 10.707 14.7314 10.8065 14.7439 10.9097C14.7564 11.013 14.7473 11.1177 14.7171 11.2173C14.687 11.3168 14.6364 11.409 14.5688 11.488L12.0208 14.461L13.5308 15.97C13.6223 16.0616 13.6885 16.1753 13.723 16.3001C13.7575 16.4248 13.7592 16.5564 13.7278 16.682L12.8118 20.345Z"
        fill="white"
      />
    </svg>
  );
};

const Love = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-label="love"
      role="img"
    >
      <path
        d="M19.9999 17C20.5732 17 21.0566 17.2 21.4499 17.6C21.8432 18 22.0366 18.4667 22.0299 19L13.9999 22L6.99989 20V11H8.94989L16.2199 13.69C16.7399 13.8967 16.9999 14.27 16.9999 14.81C16.9999 15.1233 16.8866 15.3967 16.6599 15.63C16.4332 15.8633 16.1466 15.9867 15.7999 16H12.9999L11.2499 15.33L10.9199 16.27L12.9999 17H19.9999ZM15.9999 3.23C16.7066 2.41 17.6066 2 18.6999 2C19.6066 2 20.3732 2.33333 20.9999 3C21.6266 3.66667 21.9599 4.43333 21.9999 5.3C21.9999 5.98667 21.6666 6.80667 20.9999 7.76C20.3332 8.71333 19.6766 9.51 19.0299 10.15C18.3832 10.79 17.3732 11.74 15.9999 13C14.6132 11.74 13.5932 10.79 12.9399 10.15C12.2866 9.51 11.6299 8.71333 10.9699 7.76C10.3099 6.80667 9.98655 5.98667 9.99989 5.3C9.99989 4.39333 10.3232 3.62667 10.9699 3C11.6166 2.37333 12.3966 2.04 13.3099 2C14.3766 2 15.2732 2.41 15.9999 3.23ZM0.983887 11H4.99989V22H0.983887V11Z"
        fill="white"
      />
    </svg>
  );
};
